// Lets the DIVA iframe share links to the page it is embedded on, and opens
// shared content inside the iframe when a visitor follows such a link.
// Example shared link: https://www.subaru.se/om-subaru/oi-portal/#content?id=PUBLICATION_ID&topicId=TOPIC_ID
export function initDivaIframe(): void {
    const iframes = document.querySelectorAll<HTMLIFrameElement>('iframe[src*="diva-nordics."]');

    iframes.forEach(iframe => {
        const initialUrl = new URL(iframe.src);

        // Send the parent page URL to DIVA so its Email and Copy links point here
        const sendDomain = () => {
            iframe.contentWindow?.postMessage(
                ['setDomain', window.location.origin + window.location.pathname],
                initialUrl.origin
            );
        };

        const openSharedContent = () => {
            if (!window.location.hash.startsWith('#content?')) return;

            // Convert the parent page hash into a DIVA content URL, keeping the configured language
            const url = new URL('/' + window.location.hash.slice(1), initialUrl.origin);
            const language = initialUrl.searchParams.get('language');
            if (language) url.searchParams.set('language', language);

            iframe.src = url.href;
        };

        iframe.addEventListener('load', sendDomain);

        // DIVA only starts listening once its app has initialised, which is often after the load event.
        // It posts "setHeight" to us at that point, so reply to its messages to make sure the domain arrives.
        window.addEventListener('message', (event: MessageEvent) => {
            if (event.source !== iframe.contentWindow || event.origin !== initialUrl.origin) return;
            if (Array.isArray(event.data) && event.data[0] === 'setHeight') sendDomain();
        });

        openSharedContent();
        window.addEventListener('hashchange', openSharedContent);
    });
}
